import { LandingLogo } from '@/components/LandingLogo';
import { createFileRoute } from '@tanstack/react-router'
import { initSDK } from "@/lib/analytics";
import { useEffect, useRef } from 'react';
import { useBrandConfigStore } from "@/hooks/brandConfigStore";

export const Route = createFileRoute('/(welcome-gift)/welcome-gift/result')({
  component: RouteComponent,
})

function RouteComponent() {
  const initialized = useRef(false);
  const { config } = useBrandConfigStore();

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    initSDK().catch(() => null);
  }, [])

  return (
    <div
      className="flex flex-col w-full h-full justify-center"
      style={config ? { fontFamily: config.fonts.mainFont } : undefined}
    >
      <div
        className="flex flex-col items-center text-white bg-[#D25432] pb-12 h-[95%] sm:h-[80%] px-6"
        style={config ? { backgroundColor: config.bgColors.mainColor } : undefined}
      >
        {config ? (
          <img src={config.logoUrl} alt="Logo" style={config.logoStyle} />
        ) : (
          <LandingLogo fill="#FFFFFF" width="150px" />
        )}
        <div className="rotate-15 mt-20">
          <p
            className="text-[3.2rem] text-white font-bold text-center sm:text-7xl font-frushand"
            style={config ? { fontFamily: config.fonts.titleFont } : undefined}
          >
            ENJOY<br />YOUR GIFT
          </p>
        </div>
        <div className="mt-auto">
          <p className="text-2xl font-bold text-center">your voucher code <br /> will arrive shortly via whatsapp</p>
        </div>
      </div>
    </div>
  );
}
